import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { Helper } from 'src/app/shared/Helper';
import { ApiConfiguration } from '../../../services/http/api-configuration'
declare var $: any;
@Component({
  selector: 'app-geographical-hierarchy',
  templateUrl: './geographical-hierarchy.component.html',
  styleUrls: ['./geographical-hierarchy.component.scss']
})
export class GeographicalHierarchyComponent implements OnInit {
  public createTemp = 0;
  public nodeModel = {
    "status": 1,
    "geograph_code": "", 
    "geograph_name": "", 
    "parent_geo_code": "", 
    "value_type": ""
  }
  public GeoData;
  public list;
  constructor(public router: Router, private service: ApiService, private config: ApiConfiguration, public helper: Helper, private toast: ToastClientService) { }

  ngOnInit() {
    
    this.getGeo();

   
  }

  getGeo() {
    this.service.get(this.config.getAllGeographies)
    .subscribe((res:any)=>{
      this.GeoData = res.data;
      if(this.GeoData.length > 0) {
        this.list = this.helper.createTree('', this.GeoData);
        console.log(this.list);
      }
      this.renderTree();
      
    })
  }

  onCreate(){
    console.log("created nodes")
  }
  renderTree(){
    var self = this;
    $(function () {
      // 6 create an instance when the DOM is ready
      $('#jstree').jstree({    
        "core": {    
          "check_callback": true,
          "animation":200,    
        },    
        "types" : {
          "default" : {
            "icon" : "fa fa-arrow-right text-new"
          },
          "demo" : {
            "icon" : "fa fa-ravelry"
          }
        },    
        "plugins": ["types","contextmenu", "sort", "themes", "html"],
            
    });
      // 7 bind to events triggered on the tree
      $('#jstree').on("changed.jstree", function (e, data) {
        console.log(data);
      });

      $("#jstree").on('create_node.jstree', function (e, data) {
        //data.text is the new name:
        //console.log(data.node.text);
        self.createTemp = 1;
        
      });
      $("#jstree").on('rename_node.jstree', function (e, data) {
        if(self.createTemp == 1){
          console.log("New Node Name");
          console.log(data)
          self.createTemp = 0;
          let fullname = data.node.text.split("*");
          let name = fullname[0];
          let geocode = fullname[1];
          let payload = self.nodeModel;
          payload.parent_geo_code = data.node.parent;
          payload.geograph_name = name;
          payload.geograph_code = geocode;
          console.log(payload)
          self.service.post(self.config.createGeography, payload)
          .subscribe((res:any)=>{
            //console.log(res)
            if(res.body.status == 201){
              self.toast.Success("Added Successfully");
              self.router.navigateByUrl("/hubAdmin/user-management/geographical-hierarchy")
            }
          })

        }else{
          console.log("Old Node Name");
          console.log(data)
        }
      });
      $('#jstree').on('delete_node.jstree',function(e, data){
        console.log(data);
      })
      $('#bdeViewNew').on('select_node.jstree', function (e, data) {
        var loMainSelected = data;
        console.log(data);
      });
      // 8 interact with the tree - either way is OK
      $('button').on('click', function () {
        $('#jstree').jstree(true).select_node('child_node_1');
        $('#jstree').jstree('select_node', 'child_node_1');
        $.jstree.reference('#jstree').select_node('child_node_1');
      });
    });
  }

}
